import { render, staticRenderFns } from "./DepartmentAchieveIcons.vue?vue&type=template&id=d6aafb94&"
import script from "./DepartmentAchieveIcons.vue?vue&type=script&lang=ts&"
export * from "./DepartmentAchieveIcons.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentAchieveIcons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports